export enum AppraiserActionType {
    Modify = 0,
    Restore = 1,
    Delete = 2,
}
